const openPositions = [
    {
        "title": "KFZ-Mechatroniker",
        "teaser1": "",
        "captionTasks": "Deine Aufgaben",
        "tasks": [
            'Fehleranalyse an elektrischen und mechanischen Systemen mit modernster Analysetechnik (z.B. elektronische Diagnose- und Testgeräte)',
            'Wartungs- und Instandsetzungsarbeiten an Nutzfahrzeugen jeglicher Art (vom Sattelschlepper mit Spezialaufbauten bis zum Feuerwehrfahrzeug)',
            'Vorbereitung der Fahrzeuge auf die Hauptuntersuchung, sowie derer Durchführung',
            'Durchführen von Sicherheitsprüfungen und Abgasuntersuchungen (bei vorhandener Qualifikation)'
        ],
        "lookingFor": [
            'Abgeschlossene Berufsausbildung zum KFZ-Mechatroniker',
            'Erfahrung in der Instandsetzung von LKWs und Nutzfahrzeugen',
            'Grundkenntnisse in der Hydraulik/Pneumatik und KFZ-Elektrik',
            'Eigenständige, teamorientierte Arbeitsweise',
            'Kundenorientiertes Handeln und Zuverlässigkeit',
            'Bereitschaft zur gelegentlichen Samstagsarbeit'
        ],
        'captionBeneftis': "Was wir Dir bieten",
        "benefits": [
            'Langfristige Festanstellung in einem spannenden und abwechslungsreichen Umfeld',
            'Motiviertes Team',
            'Familiäres und lockeres Arbeitsklima',
            'Flache Hierarchien',
            'Unterstützung Deiner individuellen Laufbahn (z.B. durch qualifizierte Lehrgänge)',
            '38 Stunden-Woche',
            '30 Tage Erholungsurlaub',
            'Übertarifliche Bezahlung',
            'Zuschüsse zur betrieblichen Altersvorsorge und vermögenswirksame Leistungen',
            'Urlaubsgeld',
            'Weihnachtsgeld',
            'kostenlose Bereitstellung von Arbeitskleidung',
            'Betriebsfeiern (z.B. Weihnachtsfeier, Grillen)',
            'Kleine Aufmerksamkeiten, wie Obstkörbe'
        ],
        'teaser2': "Konnten wir Dein Interesse wecken? Dann sende uns jetzt Deine Bewerbungsunterlagen zu und werde ein Teil von unserem Team!"
    },
    {
        "title": "Auszubildender zum KFZ-Mechatroniker",
        "teaser1": "",
        "captionTasks": "Das wirst du in Deiner Ausbildung lernen",
        "tasks": [
            'Instandhaltung und Wartung von Nutzfahrzeugen',
            'Pneumatik',
            'Hydraulik',
            'Elektrik/Elektronik',
            'Fehlersuche mit modernster Analysetechnik (z.B. elektronische Diagnose- und Testgeräte)'
        ],
        "lookingFor": [
            'Mindestens Hauptschulabschluss',
            'Technisches Interesse und handwerkliches Geschick',
            'Organisationsvermögen und Kommunikationsstärke',
            'Eigenständige, teamorientierte Arbeitsweise',
            'Kundenorientiertes Handeln und Zuverlässigkeit'
        ],
        'captionBeneftis': "Was wir Dir bieten",
        "benefits": [
            'Eine anspruchsvolle und abwechslungsreiche Ausbildung',
            'Sehr gute Übernahmechancen',
            'Überbetriebliche Prüfungsvorbereitung',
            'Online-Lehrgänge bei MAN (ab dem zweiten Lehrjahr)',
            'Motiviertes Team',
            'Familiäres und lockeres Arbeitsklima',
            'Flache Hierarchien',
            'Unterstützung Deiner individuellen Laufbahn (z.B. durch qualifizierte Lehrgänge)',
            '38 Stunden-Woche',
            '30 Tage Erholungsurlaub',
            'Übertarifliche Bezahlung',
            'Zuschüsse zur betrieblichen Altersvorsorge und vermögenswirksame Leistungen',
            'Urlaubsgeld',
            'Weihnachtsgeld',
            'kostenlose Bereitstellung von Arbeitskleidung',
            'Betriebsfeiern (z.B. Weihnachtsfeier, Grillen)',
            'Kleine Aufmerksamkeiten, wie Obstkörbe'
        ],
        'teaser2': "Konnten wir Dein Interesse wecken? Dann sende uns jetzt Deine Bewerbungsunterlagen zu und werde ein Teil von unserem Team!"
    }

];

  export default openPositions;